import React from "react";
import { useSelector } from "react-redux";
import ProductListCard from "./ProductListCard";

const TopSellingProduct = () => {
  const { topSellingProducts } = useSelector((state) => state.product);
  return (
    <>
      {topSellingProducts && topSellingProducts?.length > 0 && (
        <div
          className="col-xl-3 col-lg-4 col-md-6 mb-sm-5 mb-md-0 wow animate__animated animate__fadeInUp"
          data-wow-delay={0}
        >
          <h4 className="section-title style-1 mb-30 animated animated">
            Top Selling
          </h4>
          <div className="product-list-small animated animated">
            {topSellingProducts.map((item, index) => (
              <ProductListCard key={index} item={item} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TopSellingProduct;
